<template>
  <div class="publish-page">
    <!-- 顶部导航 -->
    <div class="top-nav">
      <!-- 左侧返回按钮 -->
      <div class="back-btn" @click="$router.go(-1)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </div>

      <!-- 标题 真正居中 -->
      <div class="title-wrapper">
        <h1 class="title">{{ isEdit ? '编辑供需信息' : '发布供需信息' }}</h1>
      </div>
    </div>

    <!-- 表单区域 -->
    <div class="form-card">
      <!-- 信息类型 -->
      <div class="form-item">
        <label class="label">信息类型 <span class="red">*</span></label>
        <div class="type-switch">
          <div class="type-btn" :class="{ active: formData.infoType == 1 }" @click="formData.infoType = 1">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0fb864" stroke-width="2">
              <path d="M12 19V5"></path>
              <polyline points="5 12 12 5 19 12"></polyline>
            </svg>
            供应
          </div>
          <div class="type-btn" :class="{ active: formData.infoType == 2 }" @click="formData.infoType = 2">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <path d="M12 5v14"></path>
              <polyline points="19 12 12 19 5 12"></polyline>
            </svg>
            需求
          </div>
        </div>
      </div>

      <!-- 信息标题 -->
      <div class="form-item">
        <label class="label">信息标题 <span class="red">*</span></label>
        <div class="input-wrap">
          <input v-model="formData.title" type="text" placeholder="请输入标题，如'提供短剧后期制作服务'" />
        </div>
      </div>

      <!-- 需求类型 -->
      <div class="form-item">
        <label class="label">需求类型 <span class="red">*</span></label>
        <div class="input-wrap select-wrap" @click="openTypeDrop">
          <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
          </svg>
          <span class="select-text" :class="formData.demandType ? '' : 'placeholder'">{{ formData.demandType || '请选择类型' }}</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>

      <!-- 所在地区 -->
      <div class="form-item">
        <label class="label">所在地区 <span class="red">*</span></label>
        <div class="input-wrap select-wrap" @click="openAreaDrop">
          <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="select-text" :class="areaInfo.name ? '' : 'placeholder'">{{ areaInfo.name || '请选择地区' }}</span>
          <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>

      <!-- 预算范围 -->
      <div class="form-item">
        <label class="label">预算范围</label>
        <div class="budget-row">
          <div class="input-wrap">
            <input v-model="formData.budgetMin" type="number" placeholder="最低" />
          </div>
          <span class="line">-</span>
          <div class="input-wrap">
            <input v-model="formData.budgetMax" type="number" placeholder="最高" />
          </div>
        </div>
      </div>

      <!-- 详细描述 -->
      <div class="form-item">
        <label class="label">详细描述 <span class="red">*</span></label>
        <div class="textarea-wrap">
          <textarea v-model="formData.content" placeholder="请详细描述您的供需信息，包括具体要求、时间周期、联系方式等..."></textarea>
        </div>
      </div>

      <div class="form-item">
        <label class="label">联系电话 <span class="optional">(电话或邮箱至少填写一个)</span></label>
        <div class="input-wrap">
          <input v-model.trim="formData.contactTell" placeholder="请输入联系电话"></input>
        </div>
      </div>

      <div class="form-item">
        <label class="label">联系邮箱 <span class="optional">(电话或邮箱至少填写一个)</span></label>
        <div class="input-wrap">
          <input v-model.trim="formData.email" type="email" placeholder="请输入联系邮箱"></input>
        </div>
      </div>

      <!-- 添加图片 -->
      <div class="form-item">
        <label class="label">添加图片 <span class="optional">(选填，最多9张)</span></label>
        <div class="image-upload-wrap">
          <!-- 已上传图片预览 -->
          <div class="uploaded-images" v-if="uploadImages.length > 0">
            <div class="img-item" v-for="(img, index) in uploadImages" :key="index">
              <img :src="img" alt="" />
              <div class="delete-btn" @click="removeImage(index)">×</div>
            </div>
          </div>
          <!-- 上传按钮 -->
          <div class="add-btn" @click="triggerUpload" v-if="uploadImages.length < 9">
            <input ref="uploadRef" type="file" accept="image/*" multiple hidden @change="handleUpload" />
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <p>添加图片</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 发布按钮 -->
    <button class="publish-btn" @click="submit">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
        <path d="M22 2L11 13"></path>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
      {{ isEdit ? '保存修改' : '立即发布' }}
    </button>

    <!-- 下拉弹窗 -->
    <div class="drop-modal" v-if="showTypeDrop" @click="showTypeDrop = false">
      <div class="drop-box" @click.stop>
        <div class="drop-item" v-for="item in typeList" :key="item" @click="formData.demandType = item; showTypeDrop = false">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="drop-modal" v-if="showAreaDrop" @click="showAreaDrop = false">
      <div class="drop-box" @click.stop>
        <div class="drop-item" v-for="item in areaList" :key="item.id" @click="chooseArea(item)">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublishSupplyDemand',
  data() {
    return {
      areaInfo:{name:'',id:''},
      isEdit: false,
      editId: '',
      formData: {
        infoType:1,
        title: '',
        demandType: '',
        address: null,
        budgetMin: null,
        budgetMax: null,
        content: '',
        contactTell:'',
        email: '',
        imageFileIds:[]
      },
      uploadImages: [],
      showTypeDrop: false,
      showAreaDrop: false,
      typeList: ['剧本', '人才', '制作', '发行', '文旅', '品牌', '投资', '服务', '其它'],
      areaList: [],
      uploadingCount: 0,
      submitting: false
    }
  },
  mounted () {
    this.editId = this.$route.query.id || ''
    this.isEdit = !!this.editId
    this.getRegion('')
    if (this.isEdit) {
      this.getDetail()
    }
  },
  methods: {
    getDetail() {
      this.$ajax.get('/api/supplyDemand/own/detail', {
        params: { id: this.editId }
      }).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data || {}
          this.formData = {
            infoType: data.infoType || 1,
            title: data.title || '',
            demandType: data.demandType || '',
            address: data.address || null,
            budgetMin: data.budgetMin === null || data.budgetMin === undefined ? null : data.budgetMin,
            budgetMax: data.budgetMax === null || data.budgetMax === undefined ? null : data.budgetMax,
            content: data.content || '',
            contactTell: data.contactTell || '',
            email: data.email || '',
            imageFileIds: data.imageIds || []
          }
          this.areaInfo = { id: data.address || '', name: data.addressName || '' }
          this.uploadImages = data.imageFileIds || []
        }
      })
    },
    chooseArea(val){
      if(val.parentId == 0){
        this.getRegion(val.id)
      }else{
        this.areaInfo = val
        this.showAreaDrop = false
      }
    },
    getRegion(id){
      this.$ajax.get('/api/region/get',{
        params:{
          parentId:id
        }
      }).then((res) => {
        if(res.data.code == 200){
          this.areaList = [{name:'全部地区',id:''},...res.data.data]
        }
      })
    },
    triggerUpload() {
      this.$refs.uploadRef.click()
    },
    handleUpload(e) {
      const files = Array.from(e.target.files || [])
      const remaining = 9 - this.uploadImages.length
      if (!files.length) return
      if (files.length > remaining) {
        this.$toast.error(`最多再上传${remaining}张图片`)
        e.target.value = ''
        return
      }
      files.reduce((chain, file) => chain.then(() => this.uploadImageFile(file)), Promise.resolve()).finally(() => {
        e.target.value = ''
      })
    },
    uploadImageFile(file) {
      if (file.size > 5 * 1024 * 1024) {
        this.$toast.error('图片大小不能超过5MB')
        return Promise.resolve()
      }
      const targetIndex = this.uploadImages.length
      this.uploadImages.push('')
      this.formData.imageFileIds.push(null)

      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.$set(this.uploadImages, targetIndex, reader.result)
      }

      let formData = new FormData()
      formData.append('file', file)
      this.uploadingCount += 1
      return this.$ajax.post('/api/resourceFile/upload', formData).then((res) => {
        if(res.data.code == 200){
          this.$set(this.formData.imageFileIds, targetIndex, res.data.data)
        } else {
          this.removeImage(targetIndex)
          this.$toast.error(res.data.message || '图片上传失败')
        }
      }).catch(() => {
        this.removeImage(targetIndex)
        this.$toast.error('图片上传失败，请稍后重试')
      }).finally(() => {
        this.uploadingCount = Math.max(0, this.uploadingCount - 1)
      })
    },
    removeImage(index) {
      this.uploadImages.splice(index, 1)
      this.formData.imageFileIds.splice(index, 1)
    },
    openTypeDrop() {
      this.showTypeDrop = true
    },
    openAreaDrop() {
      this.showAreaDrop = true
    },
    submit() {
      if (this.submitting) return
      if (this.uploadingCount > 0 || this.formData.imageFileIds.some(id => !id)) {
        this.$toast.error('图片仍在上传，请稍后提交')
        return
      }
      this.formData.address = this.areaInfo.id
      if (!this.formData.title || !this.formData.demandType || !this.formData.address || !this.formData.content) {
        this.$toast.error('请填写完整信息')
        return
      }
      if (!this.formData.contactTell && !this.formData.email) {
        this.$toast.error('请填写联系电话或联系邮箱')
        return
      }
      if (this.formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        this.$toast.error('邮箱格式不正确')
        return
      }
      if (this.formData.budgetMin !== null && this.formData.budgetMax !== null && Number(this.formData.budgetMin) > Number(this.formData.budgetMax)) {
        this.$toast.error('最低预算不能大于最高预算')
        return
      }
      this.formData.budgetMin = this.formData.budgetMin === '' ? null : this.formData.budgetMin
      this.formData.budgetMax = this.formData.budgetMax === '' ? null : this.formData.budgetMax
      // 这里写提交逻辑
      const url = this.isEdit ? '/api/supplyDemand/update' : '/api/supplyDemand/publish'
      const params = this.isEdit ? { ...this.formData, id: this.editId } : { ...this.formData }
      this.submitting = true
      this.$ajax.post(url, params).then((res) => {
        if(res.data.code == 200){
          this.$toast.success(this.isEdit ? '修改成功，等待审核' : '提交成功，等待审核')
          this.$router.replace('/supply-demand')
        } else {
          this.$toast.error(res.data.message || '提交失败')
        }
      }).catch(() => {
        this.$toast.error('提交失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style scoped>
.publish-page {
  background-color: white;
  min-height: 100vh;
}
/* 顶部导航 */
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  position: relative; /* 关键 */
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
}
/* 标题容器：绝对居中，不受左右影响 */
.title-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  pointer-events: auto;
}
/* 表单卡片 */
.form-card {
  padding: 20px;
}
.form-item {
  margin-bottom: 24px;
}
.label {
  display: block;
  font-size: 13px;
  color: #333;
  margin-bottom: 8px;
}
.red {
  color: #ff4d4f;
}
.optional {
  color: #999;
  font-weight: normal;
}
/* 供应/需求切换 */
.type-switch {
  display: flex;
  background: #f5f7fa;
  border-radius: 12px;
  padding: 4px;
}
.type-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 0;
  border-radius: 8px;
  font-size: 14px;
  color: #999;
}
.type-btn.active {
  background: #fff;
  color: #0fb864;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
/* 输入框 */
.input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 0 12px;
  height: 56px;
  background: #f9fafb;
}
.input-wrap .icon {
  margin-right: 8px;
  flex-shrink: 0;
}
.input-wrap input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #333;
}
.input-wrap input::placeholder {
  color: #aaa;
}
.select-wrap {
  justify-content: space-between;
  cursor: pointer;
}
.select-text {
  flex: 1;
  font-size: 14px;
  color: #333;
}
.select-text.placeholder {
  color: #aaa;
}
/* 预算区间 */
.budget-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.budget-row .input-wrap {
  flex: 1;
  max-width: 150px;
}
.budget-row .line {
  color: #999;
  font-size: 16px;
}
/* 文本域 */
.textarea-wrap {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  background: #f9fafb;
}
.textarea-wrap textarea {
  width: 100%;
  min-height: 120px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #333;
  resize: none;
}
.textarea-wrap textarea::placeholder {
  color: #aaa;
}
/* 图片上传 */
.image-upload-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.uploaded-images {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.img-item {
  position: relative;
  width: 80px;
  height: 80px;
}
.img-item img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.delete-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 20px;
  height: 20px;
  background: #ff4d4f;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.add-btn {
  width: 80px;
  height: 80px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.add-btn p {
  font-size: 11px;
  color: #999;
  margin-top: 4px;
}
/* 发布按钮 */
.publish-btn {
  width: calc(100% - 40px);
  margin: 20px;
  background: #165DFF;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
/* 下拉弹窗 */
.drop-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.drop-box {
  width: 80%;
  background: #fff;
  border-radius: 12px;
  overflow: auto;
  max-height: 400px;
}
.drop-item {
  padding: 14px 20px;
  font-size: 13px;
  color: #333;
}
.drop-item:active {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/components/add.vue